import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useToggle from '../../../hooks/useToggle';
import { resetAll } from '../../../features/StateHandle/resetStateAction';
import { openSnackbar } from '../../../features/SnackBar/snackBarSlice';
import { register } from '../../../features/Auth/authAction';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Full name is required'),
  orgName: Yup.string().required('Organization name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password should be at least 8 characters long')
    .test('contains-lowercase', 'Password should contain at least one lowercase letter', (value) => {
      return /[a-z]/.test(value);
    })
    .test('contains-uppercase', 'Password should contain at least one uppercase letter', (value) => {
      return /[A-Z]/.test(value);
    })
    .test('contains-digit', 'Password should contain at least one digit', (value) => {
      return /[0-9]/.test(value);
    })
    .test('contains-special-char', 'Password should contain at least one special character ', (value) => {
      return /[@$!%*?&]/.test(value);
    }),
});

const useRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useToggle(false);

  const initialValues = {
    name: '',
    email: '',
    password: '',
    orgName: '',
  };

  const handleSubmit = (values) => {
    dispatch(register(values)).then((res) => {
      const { error, payload } = res;

      if (error) {
        const err = payload.message || payload;
        dispatch(openSnackbar({ open: true, message: err, type: 'error' }));
        return;
      }

      dispatch(openSnackbar({ open: true, message: payload.message, type: 'success' }));
      navigate('/');
    });
  };

  const handleBackToLogin = () => {
    dispatch(resetAll());
  };

  return {
    initialValues,
    auth,
    handleSubmit,
    handleBackToLogin,
    validationSchema,
    showPassword,
    setShowPassword,
  };
};

export default useRegister;
